import { atom } from "jotai";

import { clientConfigAtom } from "atoms/clientConfig";
import { vinAtom, vinPhotoAtom } from "./vin";
import { vinValidator } from "pages/Vin/VinValidator";

export const isVinValidAtom = atom((get) => {
  const vin = get(vinAtom);
  const vinPhoto = get(vinPhotoAtom);
  const { vin: vinConfig } = get(clientConfigAtom);

  const validations = {
    ...(vinConfig?.showVinInput && {
      vinHasValue: vinValidator(vin),
    }),
    ...(!vinConfig?.showVinInput && { vinHasPhoto: vinPhoto.length > 0 }),
  };

  return validations
});
